module.exports = __webpack_public_path__ + "static/img/5.6bdbd98.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/zh/5.png
// module id = rxjn
// module chunks = 0